import { WifiOff, RefreshCw, CheckCircle2, AlertTriangle } from "lucide-react";
import { useConnectivity } from "@/lib/offline/connectivity";

// Non-blocking connectivity banner. Hidden when ONLINE with nothing to say.
export default function OfflineBanner() {
  const c = useConnectivity();
  if (c.status === "ONLINE" && !c.message) return null;
  const map = {
    OFFLINE: ["bg-amber-500 text-amber-950", WifiOff, `Offline — cash sales are available. Online payments and credit are unavailable.${c.pending ? ` ${c.pending} offline sale${c.pending === 1 ? "" : "s"} waiting to sync.` : ""}`],
    RECONNECTING: ["bg-sky-600 text-white", RefreshCw, "Internet restored — reconnecting."],
    SYNCING: ["bg-sky-600 text-white", RefreshCw, c.message || "Syncing offline sales…"],
    SYNC_ERROR: ["bg-rose-600 text-white", AlertTriangle, c.message || "1 sale needs attention. Open Offline Sync."],
    ONLINE: ["bg-emerald-600 text-white", CheckCircle2, c.message],
  };
  const [cls, Icon, text] = map[c.status] || map.ONLINE;
  return (
    <div className={`w-full px-4 py-1.5 text-xs font-semibold flex items-center justify-center gap-2 ${cls}`} role="status" data-testid="connectivity-banner" data-status={c.status}>
      <Icon className={`w-3.5 h-3.5 ${c.status === "SYNCING" || c.status === "RECONNECTING" ? "animate-spin" : ""}`} /> <span data-testid="connectivity-banner-text">{text}</span>
    </div>
  );
}
